import React from 'react';
import * as S from './style';
import Image from '../common/Image';
import GiftImage from '~images/loggedout/home/gift_image.png';
// import KidsafeImage from '~images/loggedout/home/kidsafe.png';
import { lightWhite } from '../shared-styles/Colors';
// import MediaQuery from 'react-responsive';
import { breakpoints, MediaQuery } from '../../../utils/responsive_utilities';
import { trackToGtmFE } from '../../../utils/gtm-event-common';

const Footer = ({showOddbodsTrademark}) => {

  const onClickGTMFooter = (eventParams) => {
      trackToGtmFE('clicked_footer',eventParams);
  }
  
  return (
    <S.Wrapper>
      <div className="content-container">
        <S.Flex1>
          {linksArr.map((linkset, index) => {
            return (
              <S.List key={index}>
                <S.ListItem>{linkset.mainLink}</S.ListItem>
                {linkset.sublinks.map((sublink, subindex, links) => {
                  return (
                    <S.ListItem sublink key={sublink.title}>
                      <a
                        href={sublink.link}
                        target={sublink.target ? '_target' : ''}
                        onClick={() => onClickGTMFooter({'Click Text': sublink.title,'Click URL': sublink.link})}
                      >
                        {sublink.title}
                      </a>
                    </S.ListItem>
                  );
                })}
              </S.List>
            );
          })}
          <S.KidsafeDiv>
            <div style={{ flexGrow: 1 }}></div>
            <a href="https://crmlp.splashlearn.com/gift" aria-label='Gift a subscription' onClick={() => onClickGTMFooter({'Click Text': 'Gift','Click URL': 'https://crmlp.splashlearn.com/gift'})}>
              <Image src={GiftImage} alt="gift-image" />
            </a>
          </S.KidsafeDiv>
        </S.Flex1>
        <MediaQuery query={`(min-width: ${breakpoints.xl}px)`}>
          <S.Line></S.Line>
        </MediaQuery>
        <S.Flex2>
          <div>
            <S.ListItem as="span">
              {/* <Link to={TERMS_OF_USE_PATH}>Terms of use</Link> */}
              <a href="/terms-of-use" onClick={() => onClickGTMFooter({'Click Text': 'Terms of use','Click URL': '/terms-of-use'})}>Terms of use</a>
            </S.ListItem>
            <span style={{ color: lightWhite }}>{' | '}</span>
            <S.ListItem as="span">
              {/* <Link to={PRIVACY_PATH}>Privacy Policy</Link> */}
              <a href="/privacy" onClick={() => onClickGTMFooter({'Click Text': 'Privacy Policy','Click URL': '/privacy'})} >Privacy Policy</a>
            </S.ListItem>
            <S.Trademarks>
              StudyPad & SplashLearn are registered Trademarks of StudyPad, Inc.{' '}
            </S.Trademarks>
            {showOddbodsTrademark &&
              <S.OddbodsTrademark>
                <S.Trademarks>
                  © One Animation.
                </S.Trademarks>
                <S.Trademarks>
                  ODDBODS (Stylised) is a U.S. Registered Trademark of One Animation Pte Ltd.
                </S.Trademarks>
              </S.OddbodsTrademark>
            }
          </div>
          <S.KidsafeDiv>
            <div style={{ flexGrow: 1 }}></div>
            <a href="https://www.kidsafeseal.com/certifiedproducts/splashlearn.html" aria-label='Read about Kidsafe seal program' onClick={() => onClickGTMFooter({'Click Text': 'Kid Safe','Click URL': 'https://www.kidsafeseal.com/certifiedproducts/splashlearn.html'})}>
              <img src="https://www.kidsafeseal.com/sealimage/5098186132059937251/splashlearn_large_whitetm.png" alt="kidsafe" width="100%" height="100%" />

            </a>
          </S.KidsafeDiv>
        </S.Flex2>
      </div>
    </S.Wrapper>
  );
};

const linksArr = [
  // dummy array for now. Later we need to specify paths also to make these clickable.
  {
    mainLink: 'Math Games for Kids',
    sublinks: [
      {
        title: 'Number Sense Games',
        link: '/math/number-sense-games',
      },
      {
        title: 'Place Value Games',
        link: '/math/place-value-games',
      },
      {
        title: 'Addition Games',
        link: '/math/addition-games',
      },
      {
        title: 'Subtraction Games',
        link: '/math/subtraction-games',
      },
      {
        title: 'Multiplication Games',
        link: '/math/multiplication-games',
      },
      {
        title: 'Fraction Games',
        link: '/math/fractions-games',
      },
      {
        title: 'Decimal Games',
        link: '/math/decimals-games',
      },
      {
        title: 'Geometry Games',
        link: '/math/geometry-games',
      },
      {
        title: 'Time Games',
        link: '/math/time-games',
      },
      {
        title: 'Counting Money Games',
        link: '/math/counting-money-games',
      },
    ],
  },
  {
    mainLink: 'ELA Games for Kids',
    sublinks: [
      {
        title: 'Reading Games',
        link: '/ela/reading-games',
      },
      {
        title: 'Writing Games',
        link: '/ela/writing-games',
      },
      {
        title: 'Phonics Games',
        link: '/ela/phonics-games',
      },
      {
        title: 'Alphabet Games',
        link: '/ela/alphabet-games',
      },
      {
        title: 'Letter Sound Games',
        link: '/ela/letter-sounds-games',
      },
      {
        title: 'CVC Word Games',
        link: '/ela/cvc-words-games',
      },
      {
        title: 'Rhyming Word Games',
        link: '/ela/rhyming-words-games',
      },
      {
        title: 'Sight Words Games',
        link: '/ela/sight-words-games',
      },
      {
        title: 'Letter Tracing Games',
        link: '/ela/letter-tracing-games',
      },
      {
        title: 'Writing Sight Words Games',
        link: '/ela/writing-sight-words-games',
      },
    ],
  },
  {
    mainLink: 'Browse by Subject & Grade',
    sublinks: [
      {
        title: 'Math',
        link: '/math',
      },
      {
        title: 'ELA',
        link: '/ela',
      },
      {
        title: 'Preschool',
        link: '/preschoolers',
      },
      {
        title: 'Kindergarten',
        link: '/kindergarteners',
      },
      {
        title: 'Grade 1',
        link: '/1st-graders',
      },
      {
        title: 'Grade 2',
        link: '/2nd-graders',
      },
      {
        title: 'Grade 3',
        link: '/3rd-graders',
      },
      {
        title: 'Grade 4',
        link: '/4th-graders',
      },
      {
        title: 'Grade 5',
        link: '/5th-graders',
      },
    ],
  },
  {
    mainLink: 'SplashLearn Content',
    sublinks: [
      {
        title: 'For Classrooms',
        link: '/features/teachers',
      },
      {
        title: 'For Homeschoolers',
        link: '/features/parents',
      },
      {
        title: 'Math Games',
        link: '/math-games',
      },
      {
        title: 'Math Games for Kindergarten',
        link: '/math-games-for-kindergarteners',
      },
      {
        title: 'Math Games for 1st Grader',
        link: '/math-games-for-1st-graders',
      },
      {
        title: 'Math Games for 2nd Grader',
        link: '/math-games-for-2nd-graders',
      },
      {
        title: 'Math Games for 3rd Grader',
        link: '/math-games-for-3rd-graders',
      },
      {
        title: 'Math Games for 4th Grader',
        link: '/math-games-for-4th-graders',
      },
      {
        title: 'Math Games for 5th Grader',
        link: '/math-games-for-5th-graders',
      },
      {
        title: 'Common Core Math Vocabulary',
        link: '/math-vocabulary',
      },
    ],
  },
  {
    mainLink: 'Resources',
    sublinks: [
      {
        title: 'Blog',
        link: 'https://www.splashlearn.com/blog/',
      },
      {
        title: 'About Us',
        link: '/about',
      },
      {
        title: 'Careers',
        link: 'https://www.splashlearn.com/careers/',
      },
      {
        title: 'Contact Us',
        link: '/about/contact-us',
      },
      {
        title: 'SplashLearn Success Stories',
        link: '/success-stories',
      },
      {
        title: 'SplashLearn Apps',
        link: '/apps',
      },
      // {
      //   title: 'SplashLearn Affiliates',
      //   link: '/affiliates',
      // },
      {
        title: 'Help',
        link: 'http://support.splashmath.com',
        target: true,
      },
    ],
  },
];
export default Footer;
